import { useContext } from "react";
import AuthContext from "../context/auth/AuthContext";
import {
  WORKSPACE_FEATURES,
  isWorkspaceFeatureEnabled,
} from "../helper/workspaceRequirements";

// Usage:
//   const { isEnabled, FEATURES } = useWorkspaceRequirements();
//   if (!isEnabled(FEATURES.AML)) { ...show it locked... }
//
// The config comes from the logged-in landlord's current workspace
// (`user.current_workspace.requirements_config`).
const useWorkspaceRequirements = () => {
  const { user } = useContext(AuthContext);
  const userType = localStorage.getItem("usertype");

  const isEnabled = (feature) =>
    isWorkspaceFeatureEnabled({
      workspace: user?.current_workspace,
      userType,
      feature,
    });

  return { isEnabled, FEATURES: WORKSPACE_FEATURES };
};

export default useWorkspaceRequirements;
